import React from 'react';

/**
 * 月ナビゲーター共通コンポーネント
 * Props:
 *   year: number
 *   month: number  (1-12)
 *   onChange: (year, month) => void
 *   showAllToggle: bool   ← 「全期間」ボタンを出すか
 *   showAll: bool
 *   onToggleAll: () => void
 */
export default function MonthNavigator({ year, month, onChange, showAllToggle = false, showAll = false, onToggleAll }) {
  const now = new Date();

  const prev = () => {
    if (month === 1) onChange(year - 1, 12);
    else onChange(year, month - 1);
  };

  const next = () => {
    if (month === 12) onChange(year + 1, 1);
    else onChange(year, month + 1);
  };

  const isCurrentMonth = year === now.getFullYear() && month === now.getMonth() + 1;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      {/* 前月 */}
      <button onClick={prev} style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: 8, color: '#94a3b8', fontSize: 16, width: 34, height: 34, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>‹</button>

      {/* 年月表示 */}
      <div style={{ background: showAll ? '#1e293b' : '#312e81', border: `1px solid ${showAll ? '#334155' : '#6366f1'}`, borderRadius: 10, padding: '6px 16px', minWidth: 110, textAlign: 'center' }}>
        <span style={{ fontSize: 14, fontWeight: 700, color: showAll ? '#64748b' : '#f1f5f9' }}>
          {showAll ? '全期間' : `${year}年${month}月`}
        </span>
      </div>

      {/* 次月 */}
      <button onClick={next} style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: 8, color: '#94a3b8', fontSize: 16, width: 34, height: 34, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>›</button>

      {/* 今月に戻る */}
      {!isCurrentMonth && !showAll && (
        <button onClick={() => onChange(now.getFullYear(), now.getMonth() + 1)}
          style={{ background: 'none', border: '1px solid #334155', borderRadius: 8, color: '#6366f1', fontSize: 11, padding: '5px 10px', cursor: 'pointer' }}>
          今月
        </button>
      )}

      {/* 全期間トグル */}
      {showAllToggle && (
        <button onClick={onToggleAll}
          style={{ background: 'none', border: `1px solid ${showAll ? '#6366f1' : '#334155'}`, borderRadius: 8, color: showAll ? '#a5b4fc' : '#475569', fontSize: 11, padding: '5px 10px', cursor: 'pointer' }}>
          {showAll ? '月別に戻す' : '全期間'}
        </button>
      )}
    </div>
  );
}
